function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import PropTypes from 'prop-types';
import Collapse from '@material-ui/core/Collapse';
import Typography from '../Typography';
import propTypeChildren from '@signal/prop-types/children';
import Button from '../Button';
import { Wrapper, Summary, Details } from './styles';
export var ExpansionPanel = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ExpansionPanel, _React$PureComponent);

  var _super = _createSuper(ExpansionPanel);

  function ExpansionPanel(props) {
    var _this;

    _classCallCheck(this, ExpansionPanel);

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this, props].concat(args));

    _defineProperty(_assertThisInitialized(_this), "isControlled", null);

    _defineProperty(_assertThisInitialized(_this), "state", {});

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      var expanded = _this.isControlled ? _this.props.expanded : _this.state.expanded;

      if (!_this.isControlled) {
        _this.setState({
          expanded: !expanded
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(event, !expanded);
      }
    });

    _this.isControlled = props.expanded != null;

    if (!_this.isControlled) {
      // not controlled, use internal state
      _this.state.expanded = props.defaultExpanded !== undefined ? props.defaultExpanded : false;
    }

    return _this;
  }

  _createClass(ExpansionPanel, [{
    key: "showHideButtonLabel",
    get: function get() {
      var showHideLabel = this.props.showHideLabel;
      var expanded = this.isControlled ? this.props.expanded : this.state.expanded;
      var showHideLabelPrefix = !expanded ? 'Show' : 'Hide';
      return "".concat(showHideLabelPrefix, " ").concat(showHideLabel);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          title = _this$props.title,
          expandedProp = _this$props.expanded,
          TitleProps = _this$props.TitleProps,
          ButtonProps = _this$props.ButtonProps,
          style = _this$props.style,
          className = _this$props.className;
      var expanded = this.isControlled ? expandedProp : this.state.expanded;
      var collapseProps = !expanded ? {
        'aria-hidden': 'true'
      } : null;
      return /*#__PURE__*/React.createElement(Wrapper, {
        style: style,
        className: className
      }, /*#__PURE__*/React.createElement(Summary, null, /*#__PURE__*/React.createElement(Typography, Object.assign({
        variant: "h3",
        color: "textDark"
      }, TitleProps), title), /*#__PURE__*/React.createElement(Button, Object.assign({
        variant: "outlined",
        size: "small",
        onClick: this.handleChange
      }, ButtonProps), this.showHideButtonLabel)), /*#__PURE__*/React.createElement(Collapse, Object.assign({
        in: expanded,
        timeout: "auto"
      }, collapseProps), /*#__PURE__*/React.createElement(Details, null, children)));
    }
  }]);

  return ExpansionPanel;
}(React.PureComponent);

_defineProperty(ExpansionPanel, "propTypes", {
  title: PropTypes.string.isRequired,
  showHideLabel: PropTypes.string,

  /**
   * If `true`, expands the panel, otherwise collapse it.
   * Setting this prop enables control over the panel.
   */
  expanded: PropTypes.bool,

  /**
   * If `true`, expands the panel by default.
   */
  defaultExpanded: PropTypes.bool,

  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} expanded The `expanded` state of the panel
   */
  onChange: PropTypes.func,

  /**
   * Properties applied to the title's `Typography` element.
   */
  TitleProps: PropTypes.object,

  /**
   * Properties applied to the show/hide `Button` element.
   */
  ButtonProps: PropTypes.object,
  children: propTypeChildren
});

_defineProperty(ExpansionPanel, "defaultProps", {
  showHideLabel: 'Summary'
});

export default ExpansionPanel;